import React from "react";

// Window showing regulatory violations / flagged findings up to the current step
export default function ViolationsPanel({ wf, step, started }) {
  if (!wf || !started) {
    return (
      <div className="lcx-box">
        <p style={{ fontSize: "0.8rem", opacity: 0.6, margin: 0 }}>
          Run the workflow to see regulatory violations flagged in real time.
        </p>
      </div>
    );
  }

  const violations = [];
  wf.steps.slice(0, step + 1).forEach((s) => {
    s.fields.forEach((f) => {
      if (f.c === "warn" || f.c === "err") {
        violations.push({ id: `${s.label}-${f.k}`, step: s.label, icon: s.icon, reg: s.reg, k: f.k, v: f.v, severity: f.c });
      }
    });
  });

  return (
    <div className="lcx-box" style={{ maxHeight: "340px", overflowY: "auto" }}>
      <div style={{ fontWeight: 700, marginBottom: "0.6rem", color: "#f59e0b" }}>
        ⚠️ Regulatory Violations &amp; Flags <span style={{ opacity: 0.65, fontWeight: 400, fontSize: "0.75rem", color: "inherit" }}>— {violations.length} flagged item{violations.length === 1 ? "" : "s"} requiring human review</span>
      </div>
      {violations.length === 0 ? (
        <p style={{ fontSize: "0.8rem", opacity: 0.65, margin: 0 }}>✅ No violations flagged so far in this run.</p>
      ) : (
        violations.map((f) => (
          <div
            key={f.id}
            style={{
              marginBottom: "0.55rem",
              padding: "0.55rem 0.7rem",
              border: `1px solid ${f.severity === "err" ? "rgba(220,80,80,0.55)" : "rgba(245,158,11,0.5)"}`,
              borderRadius: "8px",
              fontSize: "0.78rem",
            }}
          >
            <span style={{ color: f.severity === "err" ? "#ef4444" : "#f59e0b", fontWeight: 700 }}>
              {f.severity === "err" ? "⛔" : "⚠"} {f.k}:
            </span>{" "}
            <span style={{ opacity: 0.85 }}>{f.v}</span>
            <div style={{ opacity: 0.7, marginTop: "2px" }}>
              Step: {f.icon} {f.step} · Regulation: <span style={{ color: "#4FC3C3" }}>{f.reg}</span>
            </div>
          </div>
        ))
      )}
    </div>
  );
}